module.exports = __webpack_public_path__ + "fonts/dxiconsmaterial.2b9817b1.woff";